import { ProjectContext } from "context/ProjectProvider";
import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { useContext, useEffect, useState } from "react";
import { QUERY_GET_PROJECT_SPECS } from "services/graphQL/queries";
import { Button, Divider, Select } from "antd";

function SelectFeatureSpecSections(props: {
  onCreateSpecSectionClick?: any;
  selectedIds: string[];
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
  mode?: "multiple" | "tags" | "single";
  placeholder?: string;
}) {
  const {
    onCreateSpecSectionClick,
    selectedIds,
    setSelectedIds,
    mode = "multiple",
    placeholder
  } = props;

  const { gqlClientForProject, eventLogs } = useContext(ProjectContext);
  const [open, setOpen] = useState(false);

  const { data: specSections, refetch: refetchSpecs } = useCIQQuery<{
    spec_sections: Array<{
      title: string;
      id: string;
      section_number: string;
    }>;
  }>(QUERY_GET_PROJECT_SPECS, {
    client: gqlClientForProject,
    skip: !gqlClientForProject
  });

  const onChange = (values: any) => {
    if (mode === "single") setSelectedIds([values]);
    else setSelectedIds(values);
  };

  useEffect(() => {
    const hasInsertEvent = eventLogs.some(
      (log) =>
        log.data_source === "spec_sections" && log.change_type === "insert"
    );
    if (hasInsertEvent) {
      refetchSpecs();
    }
  }, [eventLogs, refetchSpecs]);

  const dropdownRender = (menu: any) => {
    return (
      <>
        {menu}
        <Divider className="my-1" style={{ margin: "8px 0" }} />
        <div className="w-full px-1">
          <Button
            className="rounded-none  bg-ciq-gray-950 bg-opacity-25 hover:bg-opacity-40 w-full"
            onClick={() => {
              setOpen(false);
              if (onCreateSpecSectionClick) {
                onCreateSpecSectionClick(true);
              }
            }}
            data-testid="featurespecsections-button"
          >
            Add New Spec Section
          </Button>
        </div>
      </>
    );
  };

  return (
    <Select
      value={selectedIds}
      showArrow
      showSearch
      placeholder={placeholder}
      mode={mode === "single" ? undefined : mode}
      filterOption={(inputValue, option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      options={specSections?.spec_sections.map((spec) => ({
        value: spec.id,
        label: spec.title
          ? `${spec.section_number} - ${spec.title}`
          : spec.section_number
      }))}
      onChange={onChange}
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      popupRender={dropdownRender}
    />
  );
}

export default SelectFeatureSpecSections;
